import { transition, trigger, useAnimation } from '@angular/animations';
import { shake } from '../attention';

export const shakeAnimation = trigger('shakeAnimation', [
  transition('* => active', [useAnimation(shake)]),
]);
